/* ==========================================================================
   BCH CO — global.js
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  var toast, toastMsg, toastTimer;
  function ensureToast() {
    if (toast) return;
    toast = document.createElement('div');
    toast.className = 'toast';
    toast.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg><span></span>';
    document.body.appendChild(toast);
    toastMsg = toast.querySelector('span');
  }
  function showToast(msg) {
    ensureToast();
    toastMsg.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2400);
  }

  /* ---------- Cart count ---------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
      el.animate(
        [{ transform: 'scale(1.6)' }, { transform: 'scale(1)' }],
        { duration: 300, easing: 'ease-out' }
      );
    });
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () {});
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function addToCart(id, qty, name) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        showToast('Added ' + (name ? '“' + name + '”' : '') + ' to your basket');
        refreshCart();
      })
      .catch(function (err) {
        showToast(err && err.description ? err.description : 'Sorry — that could not be added');
      });
  }

  // Grid quick-add buttons: <button class="add" data-variant-id data-product-title>
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    addToCart(btn.getAttribute('data-variant-id'), 1, btn.getAttribute('data-product-title'));
  });

  /* ---------- Favourite toggle (visual only) ---------- */
  document.addEventListener('click', function (e) {
    var fav = e.target.closest('.fav');
    if (!fav) return;
    e.preventDefault();
    fav.style.color = fav.classList.toggle('is-on') ? '#E44E38' : '';
  });

  /* ---------- Mobile nav ---------- */
  var burger = document.getElementById('burger');
  var navLinks = document.getElementById('navLinks');
  if (burger && navLinks) {
    burger.addEventListener('click', function () {
      var open = navLinks.classList.toggle('open');
      burger.setAttribute('aria-expanded', open);
    });
    navLinks.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        navLinks.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- Product gallery ---------- */
  var stageImg = document.querySelector('[data-stage]');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var src = t.getAttribute('data-thumb');
      if (stageImg && src) stageImg.setAttribute('src', src);
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var price = parseFloat(wrap.getAttribute('data-unit-price') || '0');
    var totalEl = document.querySelector(wrap.getAttribute('data-total-target') || '');
    function clamp() {
      var n = parseInt(input.value, 10) || 1;
      if (n < 1) n = 1; if (n > 999) n = 999;
      input.value = n; return n;
    }
    function paint() {
      var n = clamp();
      if (totalEl && price) totalEl.textContent = formatMoney(n * price);
    }
    wrap.querySelector('[data-minus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) - 1; paint(); });
    wrap.querySelector('[data-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; paint(); });
    input.addEventListener('input', paint);
    paint();
  });

  function formatMoney(pounds) {
    return '£' + pounds.toFixed(2);
  }

  /* ---------- Product form (variant-aware add) ---------- */
  var pForm = document.querySelector('[data-product-form]');
  if (pForm) {
    var variantInput = pForm.querySelector('[name="id"]');
    var qtyInput = pForm.querySelector('[name="quantity"]');
    var title = pForm.getAttribute('data-product-title');

    // variant swatches update hidden id + price
    pForm.querySelectorAll('[data-variant-option]').forEach(function (opt) {
      opt.addEventListener('change', function () {
        // gather selected values
        var selected = [];
        pForm.querySelectorAll('[data-option-index]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          if (checked) selected[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
        });
        var variants = window.__bchVariants || [];
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return selected[i] === undefined || o === selected[i]; });
        });
        if (match) {
          variantInput.value = match.id;
          var pl = document.querySelector('[data-price-live]');
          if (pl) pl.textContent = formatMoney(match.price / 100);
          var addBtn = pForm.querySelector('[type="submit"]');
          if (addBtn) {
            addBtn.disabled = !match.available;
            addBtn.querySelector('[data-btn-label]') &&
              (addBtn.querySelector('[data-btn-label]').textContent = match.available ? 'Add to basket' : 'Sold out');
          }
        }
      });
    });

    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(variantInput.value, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1, title);
    });
  }

  /* ---------- Tabs ---------- */
  document.querySelectorAll('[data-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var scope = tab.closest('[data-tabs]') || document;
      scope.querySelectorAll('[data-tab]').forEach(function (t) { t.classList.remove('active'); });
      scope.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      var panel = scope.querySelector('[data-panel="' + tab.getAttribute('data-tab') + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  /* ---------- Cart line quantity + remove (cart page) ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var key = wrap.getAttribute('data-key');
    function change(q) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: q })
      }).then(function () { window.location.reload(); });
    }
    wrap.querySelector('[data-minus]').addEventListener('click', function () {
      change(Math.max(0, (parseInt(input.value, 10) || 1) - 1));
    });
    wrap.querySelector('[data-plus]').addEventListener('click', function () {
      change((parseInt(input.value, 10) || 1) + 1);
    });
  });
  document.querySelectorAll('[data-remove]').forEach(function (b) {
    b.addEventListener('click', function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: b.getAttribute('data-remove'), quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- init ---------- */
  refreshCart();
})();
